"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuestion = exports.isGroup = exports.Group = exports.Questionnaire = exports.Question = exports.Scorepoint = exports.Answer = void 0;
var answer_1 = require("./answer");
Object.defineProperty(exports, "Answer", { enumerable: true, get: function () { return answer_1.Answer; } });
Object.defineProperty(exports, "Scorepoint", { enumerable: true, get: function () { return answer_1.Scorepoint; } });
var question_1 = require("./question");
Object.defineProperty(exports, "Question", { enumerable: true, get: function () { return question_1.Question; } });
var questionnaire_1 = require("./questionnaire");
Object.defineProperty(exports, "Questionnaire", { enumerable: true, get: function () { return questionnaire_1.Questionnaire; } });
var group_1 = require("./group");
Object.defineProperty(exports, "Group", { enumerable: true, get: function () { return group_1.Group; } });
var node_1 = require("./node");
Object.defineProperty(exports, "isGroup", { enumerable: true, get: function () { return node_1.isGroup; } });
Object.defineProperty(exports, "isQuestion", { enumerable: true, get: function () { return node_1.isQuestion; } });
